/**
 * A class containing all the information about the NBS validation
 */
export class NBSValidation {
    /**
     * Create a new NBS Validation object
     * @param {User[]} operationalBuyers
     * @param {{}} denialInfo
     * @param {[]} operationalBuyersInDL
     * @param {string} obApprover
     */
    constructor(operationalBuyers, denialInfo, operationalBuyersInDL, obApprover) {
        this._operationalBuyers = operationalBuyers;
        this._denialInfo = denialInfo;
        this._operationalBuyersInDL = operationalBuyersInDL;
        this._obApprover = obApprover;
    }

    /**
     * Get an JS object containing all the information about the NBS Validation.
     * @return {{denyMessage: {}, operationalBuyers: User[], operationalBuyersInDL: [], obApprover: string}}
     */
    getNBSValidation() {
        return {
            denialInfo: this._denialInfo,
            operationalBuyers: this._operationalBuyers,
            operationalBuyersInDL: this._operationalBuyersInDL,
            obApprover: this._obApprover,
        };
    }

    /**
     * Get the operational buyers
     * @return {User[]}
     */
    get operationalBuyers() {
        return this._operationalBuyers;
    }

    /**
     * Set the operational buyers
     * @param {User[]} value
     */
    set operationalBuyers(value) {
        this._operationalBuyers = value;
    }

    /**
     * Get the denial info
     * @return {{}}
     */
    get denialInfo() {
        return this._denialInfo;
    }

    /**
     * Set the denial info
     * @param {{}} value
     */
    set denialInfo(value) {
        this._denialInfo = value;
    }

    /**
     * Get the operationalBuyersInDL
     * @return {[]}
     */
    get operationalBuyersInDL() {
        return this._operationalBuyersInDL;
    }

    /**
     * Set the operationalBuyersInDL
     * @param {[]} value
     */
    set operationalBuyersInDL(value) {
        this._operationalBuyersInDL = value;
    };

    /**
     * Get the obApprover
     * @return {string}
     */
    get obApprover() {
        return this._obApprover;
    }

    /**
     * Set the obApprover
     * @param {string} value
     */
    set obApprover(value) {
        this._obApprover = value;
    }
}
